import { useTranslation } from 'react-i18next'
import { Platform, View } from 'react-native'
import Button from '@ui/buttons/Button'
import ModalWide from '@ui/components/Modal/variants/ModalWide'
import PaymentHelpModal from 'features/payment/modals/PaymentHelp/PaymentHelpModal'
import { useState } from 'react'
import SectionRow from '@ui/elements/SectionRow'

interface Props {
  open: boolean
  orderIds: string[]
  close: () => void
  onCheckRefundBalance: () => void
  onGlobemed?: () => void
  onRemoveGlobemed?: () => void
}

export default function PaymentActionsModal({
  open,
  orderIds,
  close,
  onCheckRefundBalance,
  onGlobemed,
  onRemoveGlobemed,
}: Props) {
  const { t } = useTranslation(['payment'])
  const text = 'payment:actions.modal'

  const [helpModalOpen, setHelpModalOpen] = useState(false)

  return (
    <>
      <ModalWide
        showClose
        center
        spacedText
        open={open}
        close={close}
        title={t(`${text}.title`)}
        desc={t(`${text}.desc`)}
        hideBottomSpace
        cardComponentProps={{
          justifyContent: Platform.select({
            web: 'center',
            default: 'flex-end',
          }),
        }}
        body={
          <View className="flex flex-col gap-8 px-8 pb-8">
            {onGlobemed && (
              <SectionRow
                icon="shield-check-filled"
                title={t(`${text}.globemed.title`)}
                desc={t(`${text}.globemed.desc`)}
                onPress={() => {
                  close()
                  onGlobemed()
                }}
                actionComponent={
                  <Button
                    noninteractive
                    variant="outlined"
                    size="xs"
                    label={t(`${text}.globemed.cta`)}
                  />
                }
              />
            )}
            {onRemoveGlobemed && (
              <SectionRow
                icon="circle-x"
                title={t(`${text}.globemedRemove.title`)}
                desc={t(`${text}.globemedRemove.desc`)}
                onPress={() => {
                  close()
                  onRemoveGlobemed()
                }}
                actionComponent={
                  <Button
                    noninteractive
                    variant="outlined"
                    size="xs"
                    label={t(`${text}.globemedRemove.cta`)}
                  />
                }
              />
            )}
            <SectionRow
              icon="cash-banknote-move-back"
              title={t(`${text}.refundBalance.title`)}
              desc={t(`${text}.refundBalance.desc`)}
              onPress={() => {
                close()
                onCheckRefundBalance()
              }}
              actionComponent={
                <Button
                  noninteractive
                  variant="outlined"
                  size="xs"
                  label={t(`${text}.refundBalance.cta`)}
                />
              }
            />
            <SectionRow
              icon="help-circle"
              title={t(`${text}.paymentIssue.title`)}
              desc={t(`${text}.paymentIssue.desc`)}
              onPress={() => {
                close()
                setHelpModalOpen(true)
              }}
              actionComponent={
                <Button
                  noninteractive
                  variant="outlined"
                  size="xs"
                  label={t(`${text}.paymentIssue.cta`)}
                />
              }
            />
          </View>
        }
      />
      <PaymentHelpModal
        open={helpModalOpen}
        orderIds={orderIds}
        close={() => setHelpModalOpen(false)}
      />
    </>
  )
}
